import Components from '@/plugins-ts/Components'
import Directives from '@/plugins-ts/Directives'
import type { App } from 'vue'

export { ClickOutside, KeyController } from '@/plugins-ts/Directives'

export const plugins = {
  install(app: App) {
    app.use(Directives)
    app.use(Components)
  },
}
